import type { ApprovalRequest } from '@shared/approval-request';
import type { StatusMeta } from '@/components/status-tone';

/** SF-T-177: what an approval request's (or T3 question's) badge says: waiting, being denied, answered or approved (SF-T-225), denied, approved, or answered (in T3, or the run moved on). */
export function approvalStatusMeta(r: Pick<ApprovalRequest, 'status' | 'stale'> & { kind?: ApprovalRequest['kind']; decision?: ApprovalRequest['decision'] }): StatusMeta {
  const declined = r.decision === 'decline';
  const question = r.kind === 'question';
  if (r.status === 'pending') return r.stale ? { label: 'No longer waiting', tone: 'neutral' } : { label: question ? 'Waiting on an answer' : 'Waiting on approval', tone: 'warning' };
  if (r.status === 'answering') return { label: 'Sending answers', tone: 'info' };
  if (r.status === 'answered') return { label: 'Answered', tone: 'success' };
  if (r.status === 'denying') return { label: 'Denying', tone: 'info' };
  if (r.status === 'denied') return { label: declined ? 'Declined' : 'Denied', tone: 'neutral' };
  if (r.status === 'approving') return { label: declined ? 'Declining' : 'Approving', tone: 'info' };
  if (r.status === 'approved') return { label: 'Approved', tone: 'success' };
  return { label: 'Answered', tone: 'success' };
}
